import React, { ChangeEvent, FormEvent } from "react";
import ReactModal from "react-modal";

interface IConfirmationDialogProps {
    isOpen: boolean;
    disableConfirm?: boolean;

    title?: string;
    description?: string | React.ReactChild | null;
    yesText?: string;
    noText?: string;

    onRequestClose?: (event?: (React.MouseEvent | React.KeyboardEvent)) => void;
    onConfirm?: () => PromiseLike<void>;
    onSuccess?: () => void;
}

interface IConfirmationDialogState {
    isDeleting: boolean | string;
    canDelete: boolean;

    [name: string]: any;
}

class ConfirmationDialog extends React.Component<IConfirmationDialogProps, IConfirmationDialogState> {
    constructor(props: Readonly<IConfirmationDialogProps>) {
        super(props);

        const state: IConfirmationDialogState = {
            isDeleting: false,
            canDelete: true,
        };

        this.state = state;

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleElementChanged = this.handleElementChanged.bind(this);
        this.requestClose = this.requestClose.bind(this);
    }

    public render() {
        if (!this.props.isOpen) {
            return null;
        }

        return (
            <ReactModal
                isOpen={this.props.isOpen} onRequestClose={this.requestClose}
                overlayClassName="modal-overlay" className="modal-content modal-larger" portalClassName="modal-deletion-portal"
                bodyOpenClassName="modal-deletion-open"
                contentLabel={this.props.title || "Confirm"}>
                <form className="input-form" name="deletion-dialog-form" onSubmit={this.handleFormSubmit}>
                    <section className="info-block">
                        <header>
                            <h3>{this.props.title || "Confirm"}</h3>
                        </header>

                        {this.props.description !== null ? <span>{this.props.description ? this.props.description : "Are you sure?"}</span> : null}
                        {this.props.children}
                        {
                            this.state.isDeleting === true
                                ? <div className="spinner lds-dual-ring" />
                                : (typeof this.state.isDeleting) === "string"
                                    ? <span className="error-text">{this.state.isDeleting}</span>
                                    : ""
                        }
                        &nbsp;
                        <div className="action-panel-dialog">
                            <button type="submit" className="button green push-right" disabled={this.props.disableConfirm === true}>{this.props.yesText || "Yes"}</button>
                            <button type="button" className="button" onClick={this.requestClose}>{this.props.disableConfirm === true ? "Close" : (this.props.noText || "No")}</button>
                        </div>
                    </section>
                </form>
            </ReactModal>
        );
    }

    private handleElementChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    private requestClose(e?: (React.MouseEvent | React.KeyboardEvent)) {
        this.setState({
            canDelete: true,
        });

        if (this.state.isDeleting !== true && this.props.onRequestClose) {
            this.props.onRequestClose(e);
        }
    }

    private async handleFormSubmit(e: FormEvent) {
        e.preventDefault();
        e.stopPropagation();

        try {
            this.setState({
                isDeleting: true
            });

            if (this.props.onConfirm) {
                await this.props.onConfirm();
            }

            this.setState({
                isDeleting: false
            }, () => {
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }

                this.requestClose();
            });
        }
        catch (e) {
            this.setState({
                isDeleting: e.message || e || "Could not delete item"
            });
        }
    }
}

export default ConfirmationDialog;
